import axios, { InternalAxiosRequestConfig} from 'axios';

const guestInstance = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_API_URL + `api/`,
    withCredentials: true,
}); 

const authInstance = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_API_URL + `api/`,
    withCredentials: true,
});

const authInterceptor = async (config: InternalAxiosRequestConfig) => {
    const token = localStorage.getItem('token');
    
    if (token) {
        config.headers = config.headers || {};
        config.headers['Authorization'] = 'Bearer ' + token;
    }
    
    return config;
};

authInstance.interceptors.request.use(authInterceptor);

export { guestInstance, authInstance };